import { type ImageLoaderProps } from 'next/image';
import { uploadcareLoader } from '@uploadcare/nextjs-loader/build/utils/loader.js';
export { transformUploadcareLoaderUrl } from '@pkgs/components/utils/uploadcareImageLoader';

const assetPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX ?? '';

export const customImageLoader = ({ src, width, quality }: ImageLoaderProps) => {
  if (new URL(src).hostname === 'storage.googleapis.com') {
    return `${assetPrefix}/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`;
  }

  return uploadcareLoader({ src, width, quality });
};

export default customImageLoader;
